<!--
    Desarrollado por: Wuilmer garcia
    // Fecha: 2021/04/02

    Historial de Modificaciones
    // Fecha Modificación: 
    // Modificación: 

    ///////////////////////////////////////////////////////////
-->

<template>
    <div>
        <!-- formulario del Usuario -->

        <v-form ref="formRetrieveUser" lazy-validation>
            <v-dialog v-model="estadoComp" persistent scrollable max-width="60%">

                <v-card>
                    <v-card-title class="modal_title">
                        <v-row class="d-flex justify-space-between py-2">
                            Recuperar Contraseña
                            <v-btn fab dark x-small class="btn_style3"   @click="$emit('close')"><v-icon dark>fa-times</v-icon></v-btn>                            
                        </v-row>
                    </v-card-title>

                    <v-divider></v-divider>

                    <v-card-text>

                        <v-row class="mt-5">

                            <v-col cols="12"  class="pt-0">
                                <v-text-field v-model="retrieveUser.user" label="Usuario" type="text" dense hide-details
                                autocomplete="off" autofocus  @keydown.enter.prevent="formKey('rEmail')" ref="rUser" >
                                </v-text-field>
                            </v-col>

                            <v-col cols="12"  class="pt-0">
                                <v-text-field v-model="retrieveUser.email" label="Correo Electrónico" type="text" dense hide-details
                                autocomplete="off" autofocus @keydown.enter.prevent="formKey('rCodigo')" ref="rEmail" >
                                </v-text-field>
                            </v-col>


                            <v-col cols="12"  class="pt-0" v-if="verficarCodigo">
                                <v-text-field v-model="retrieveUser.codigo_verificacion" label="Verificación código" type="text" dense hide-details
                                    autocomplete="off" autofocus @keydown.enter.prevent="formKey('rPassword')"  ref="rCodigo">
                                </v-text-field>
                            </v-col>

                            <v-col cols="12"  class="pt-0" v-if="verficarCodigo">
                                <v-text-field  v-model="retrieveUser.password" label="Ingrese nueva Contraseña" type="password" dense hide-details
                                    autocomplete="off"  @keydown.enter.prevent="formKey('save')" ref="rPassword">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12"  class="pt-0 red--text">
                                Se enviara un codigo de verifcacion a su correo
                            </v-col>
                        </v-row>

                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn class="btn_style3" dark tile @click="$emit('close')">Cancelar</v-btn>
                        <v-btn  v-if="!verficarCodigo" class="btn_block_style2" dark tile @click="recuperarPassword">Recuperar contraseña</v-btn>
                        <v-btn  v-if="verficarCodigo" class="btn_block_style2" dark tile @click="saveRetrieveUser" ref="save">Confirmar</v-btn>
                </v-card-actions>

                </v-card>
            </v-dialog>
                  <span v-if="test">
                    <code>
                        Datos :{{Datos}}
                    </code>
                    <code>
                        Parametros :{{parametros}}
                    </code>
                </span>
        </v-form>

        <!-- fin modal del Usuario -->

        

    </div>
</template>

<script>

    import axios,  { API_URL } from '@/helpers/axios'
    import {mapMutations } from 'vuex';

    export default {
        name:'RetrivierUser',
        
        props:{
            parametros:{
                type:Object
            },
            estadoComp:{
                type:Boolean
            },
        },


        // data: () => ({
        // data: (vm) => ({
        data: (vm) => ({
       
            session: sessionStorage, // variables de sesion del usuario
            rutaServer: API_URL,
            ////////////////////////////////////////////////////////

            //// ARREGLO PARA CAMPOS DE  EDITAR O AGREGAR USUARIOS
            
            Datos:[],
            test: false,
            
            retrieve_user:false,
            retrieveUser:{
                user:'',
                email:'',
                codigo_verificacion:'',
                password:''
            },

            
        }),


        mounted() {
            this.loadMain()
        },

        //computadas
        computed: {
         

          // Maxima Fecha Calendario
            getEndDate(){
                return  new Date().toISOString().substr(0, 10)               
            },

           computedDateFormatted () {
                return this.formatDate(this.Datos.fecnac_persona)
            },

           // AVATAR PARA USUARIOS //    
            avatarImg() {

                if(this.Datos.ruta_avatar_persona){
                    return (this.rutaServer+this.Datos.ruta_avatar_persona+this.Datos.avatar_persona)
                }else{
                    return null
                }
            },
 
            
            formTitle () {
                return this.parametros.evento === 'add' ? 'Crear Usuario' : 'Editar Usuario'
            },

             // Maxima Fecha Calendario
            maxDate(){
                return  new Date().toISOString().substr(0, 10)               
            },

          

        },

        
        
        watch: {
            // cada vez que la pregunta cambie, esta función será ejecutada
            estadoComp: function () {
                if(this.estadoComp){
                    this.loadMain()                    
                }else{
                    this.limpiarForm()
                }
            }
        },
        

        methods: {
            //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
            //  ------- MENSAJE DE SISTEMA  --------
            ...mapMutations('mensajeSis', ['setEnviarMens']),
       
            ////////////////////////////////////////////////////////

            //  ------- Cargar todos los registros principales al iniciar el componente   --------
            async loadMain(){
                this.limpiarForm() 
                this.resetValidation()
            },


            recuperarPassword(){            
                
                // validar usuario
                // validar campos formulario
                this. verficarCodigo = true
                this.setEnviarMens({tipo:"W", mensaje: "Se debe enviar un correo para obtener codigo de validacón", tiempo:null})
            },

            async saveRetrieveUser(){
                if (this.retrieveUser.user.length == 0 || this.retrieveUser.email.length == 0){
                    this.setEnviarMens({tipo:"W", mensaje: "Debe llenar los campos para procesar su solicitud", tiempo:null})
                }else{
                    const pattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.([a-zA-Z]{2,4})+$/
                    if (pattern.test(this.retrieveUser.email)){
                        let params = {usuario: this.retrieveUser.user, email: this.retrieveUser.email}
                        let response = await axios.post("/sistema/main/recoverPassword",params)
                        if (JSON.stringify(response.data.mti) == JSON.stringify("S")){
                            
                            // this.closePassword();
                            // this.clearData();
                            this.setEnviarMens({tipo: 'S', mensaje: response.data.message, tiempo:null})
                        }else{
                            this.setEnviarMens({tipo: 'W', mensaje: response.data.message, tiempo:null})
                        }
                    }else{
                        this.setEnviarMens({tipo:"W", mensaje: "Formato de correo eletrónico invalido", tiempo:null})
                    }
                }
            },

 

            limpiarForm(){     
                this.resetValidation()
            },

            resetValidation() {
                this.$refs.formRetrieveUser.resetValidation()
            },

            




        },
    }
</script>


<style scoped>
</style>